<template>
  <div>
    <v-btn @click.stop="drawer = !drawer" v-if="isLoggedIn" small fab
      ><v-icon dark>mdi-menu</v-icon></v-btn
    >

    <v-navigation-drawer v-model="drawer" height="auto" absolute temporary>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{
              currentUser
                ? currentUser.lastname + " " + currentUser.firstname
                : "Anonymous"
            }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ currentUser ? currentUser.username : "" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          router
          :to="item.route"
          @click="item.action"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getItem } from "@/helpers/persistanceStorage";

export default {
  name: "Navbar",
  data() {
    return {
      drawer: null,
      isLoggedIn: getItem("accessToken") != null,
      items: [
        {
          title: "Главная",
          icon: "mdi-home",
          route: "/",
          action: this.clearUpd,
        },
        {
          title: "Сканировать УПД",
          icon: "mdi-credit-card-scan",
          route: "/upd/scan",
          action: "",
        },
        {
          title: "Поиск УПД по номеру",
          icon: "mdi-magnify",
          route: "/upd/search",
          action: this.clearUpd,
        },
        {
          title: "Мои чеки",
          icon: "mdi-file-multiple",
          route: "/check/list",
          action: "",
        },
        {
          title: "Выход",
          icon: "mdi-account-arrow-right",
          route: "/logout",
          action: "",
        },
      ],
    };
  },
  watch: {
    $route() {
      this.isLoggedIn = getItem("accessToken") != null;
    },
  },
  computed: {
    currentUser() {
      let currentUser = this.$store.getters.currentUser;

      if (!currentUser) {
        this.$store.dispatch("get_user_info");
      }

      return currentUser;
    },
  },
  methods: {
    clearUpd() {
      this.$store.commit("finishCorrectSum");
      this.$store.commit("clearUpd");
      this.$store.commit("clearCanceledGoods");
    },
  },
};
</script>
